/**
 * Skeleton ảnh thẻ: `.sk` bọc ảnh `img.sk-anh`. Ảnh tải xong (hoặc lỗi) thì gắn `.da-tai` → CSS dừng vệt sáng và làm
 * ảnh hiện dần. Việc bắt load/error (capture, cả trang) và quét ảnh trong cache lúc tải trang nằm INLINE ở <head>
 * của layout site (không chờ module này). Ở đây chỉ quét lại ảnh Livewire chèn / đổi sau khi trang đã chạy.
 */
const quet = () => {
    document.querySelectorAll('img.sk-anh:not(.da-tai)').forEach((anh) => {
        if (anh.complete) {
            anh.classList.add('da-tai');
        }
    });
};

quet();
document.addEventListener('livewire:navigated', quet);
document.addEventListener('livewire:init', () => {
    window.Livewire.hook('morph.updated', () => requestAnimationFrame(quet));
});
